import React from 'react';
import { AnalyticsCard } from '../../../../analyticsModule/components/AnalyticsCard/AnalyticsCard';
export const AnalyticsCardWrapper = ({ enabled, ...rest }) => {
    if (!enabled)
        return null;
    return React.createElement(AnalyticsCard, { ...rest });
};
